"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterByKeys = filterByKeys;
exports.includesMatch = includesMatch;
exports.fuzzyMatch = fuzzyMatch;
/**
 * Filters a given array for a string using specified keys
 *
 * @param matchText
 * @param items
 * @param matchKeys if any item key matches the matchText, the item is returned
 */
function filterByKeys(matchText, items, matchKeys, matchFn = fuzzyMatch) {
    if (matchText.trim() === '')
        return items; //everything matches empty matchText
    return items.filter(item => matchKeys.some(key => matchFn(matchText, item[key] ?? '')));
}
/**
 * Matches when any part of itemText exactly includes the query text
 * @param queryText
 * @param itemText
 * @returns
 */
function includesMatch(queryText, itemText) {
    return itemText.toLowerCase().includes(queryText.toLowerCase());
}
/**
 * Matches with any itemText that includes the letters of the queryText in that order, regardless of separating characters
 * @param queryText
 * @param itemText
 * @returns
 */
function fuzzyMatch(queryText, itemText) {
    // TODO: Refactor
    const nameLower = itemText.toLowerCase();
    var i = 0, n = -1, l;
    var queryLower = queryText.toLowerCase();
    for (; (l = queryLower[i++]);) {
        if (!~(n = nameLower.indexOf(l, n + 1))) {
            return false;
        }
    }
    return true;
}
